import noSpace from "./modules/no-space";

export default {
    noSpace
}